import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useBundle } from '@amzn/react-arb-tools';
import { useNavigate, useLocation, generatePath } from 'react-router';
import { PrimeButton, YellowButton } from 'src/common/buttons';
import { routes } from 'src/utils/routes';
import { PreviewOrderStatus } from 'src/utils/previewOrderErrorUtils';
export const PurchaseButton = ({ isDisabled, previewOrderStatus, purchaseId, asin, refetch, isPrime, }) => {
    const [bundle, isBundleLoading] = useBundle('pages.previewOrderPage');
    const navigate = useNavigate();
    const location = useLocation();
    const Button = isPrime ? PrimeButton : YellowButton;
    let localeKey = 'placeYourOrder';
    let onButtonClick = () => {
        navigate(`${routes.thankYouPage}${location.search}`, {
            state: { purchaseId },
        });
    };
    if (previewOrderStatus === PreviewOrderStatus.UNFIXABLE_ERROR) {
        localeKey = 'backToProduct';
        onButtonClick = () => {
            const url = generatePath(routes.productDetailPage, { asin });
            navigate(`${url}${location.search}`);
        };
    }
    else if (previewOrderStatus === PreviewOrderStatus.FIXABLE_ERROR) {
        localeKey = 'retry';
        onButtonClick = refetch;
    }
    if (isBundleLoading)
        return null;
    return (_jsx(Button, { disabled: isDisabled, onClick: onButtonClick, "data-testid": "purchase-button", children: bundle.getMessage(localeKey) }));
};
